import React, { useState } from "react";
import style from "./index.module.scss";
import {
    Breadcrumb,
    Button,
    Divider,
    DatePicker,
    message,
    Tooltip
} from "antd";
import { BiUndo } from "react-icons/bi";
import StuTable from "./components/StuTable";
import { errorMessage } from "Utils/useRequest";
import moment from "moment";
import { CloudInfoListItem } from "API/navExperiment";
import { getCloudInfoList } from "API/navExperiment";

interface ProjectListModalProps {
    isShow: boolean; //资源列表是否展示
    onChange: () => void; //返回时改变资源列表展示标志为false
    projectName?: string; //实验项目名称
    cloudGuid?: string; //云ID
    nameLabel?: string; //云桌面名称
}

export default function ProjectListModal({
    isShow,
    onChange,
    projectName,
    cloudGuid,
    nameLabel
}: ProjectListModalProps) {
    const { RangePicker } = DatePicker;
    const [beginTime, setBeginTime] = useState(""); //实验开始时间
    const [endTime, setEndTime] = useState(""); //实验结束时间
    const [list, setList] = useState<CloudInfoListItem[]>([]); //资源列表
    const [loading, setLoading] = useState(false);

    async function handleSearch() {
        if (beginTime === "" || endTime === "") {
            setList([]);
            message.warn("请选择需要查询的日期范围");
        } else {
            if (cloudGuid === undefined) return;

            setLoading(true);
            try {
                const list = await getCloudInfoList(
                    cloudGuid,
                    beginTime,
                    endTime
                );
                setList(list.OrderList);
            } catch (e) {
                message.error(errorMessage(e));
            }
            setLoading(false);
        }
    }

    function onHandleBack() {
        onChange();
        setList([]);
        setBeginTime("");
        setEndTime("");
    }

    return (
        <>
            {isShow && (
                <div className={style.root}>
                    <div className={style.container}>
                        <div className={style.header}>
                            <Breadcrumb separator=">">
                                <Breadcrumb.Item onClick={onHandleBack}>
                                    <a href="#">新建实验计划</a>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>查看资源情况</Breadcrumb.Item>
                            </Breadcrumb>

                            <Button
                                className={style.back}
                                onClick={onHandleBack}>
                                <BiUndo size={16} /> 返回
                            </Button>
                        </div>

                        <Divider />

                        <div className={style.info}>
                            <div className={style.left}>
                                <div className={style.title}>
                                    实验项目：
                                    <Tooltip title={projectName}>
                                        <span>{projectName}</span>
                                    </Tooltip>
                                    云桌面名称：
                                    <Tooltip title={nameLabel}>
                                        <span>{nameLabel}</span>
                                    </Tooltip>
                                </div>
                                <div className={style.num}>
                                    资源总数：<span>{10}</span>
                                </div>
                            </div>
                            <div className={style.right}>
                                <img
                                    src={require("./img/required.png")}
                                    alt=""
                                    className={style.requiredIcon}
                                />
                                <RangePicker
                                    format="YYYY/MM/DD"
                                    onChange={dates => {
                                        if (dates.length !== 0) {
                                            setBeginTime(
                                                moment(dates[0]!).format(
                                                    "YYYY/MM/DD"
                                                )
                                            );
                                            setEndTime(
                                                moment(dates[1]!).format(
                                                    "YYYY/MM/DD"
                                                )
                                            );
                                        } else {
                                            setBeginTime("");
                                            setEndTime("");
                                        }
                                    }}
                                    className={style.rangePicker}
                                />
                                <Button
                                    type="primary"
                                    icon="search"
                                    className={style.searchBtn}
                                    onClick={handleSearch}>
                                    查询
                                </Button>
                            </div>
                        </div>

                        <StuTable data={list} loading={loading} />
                    </div>
                </div>
            )}
        </>
    );
}
